import React, { Fragment, useEffect, useState } from "react";
import Header from "../../../../components/Header/Header";
import { useBlockLibraries } from "../../../../Api/newSockets.api";
import { useRouteMatch } from "react-router";
import { savePathToLocalStorage } from "../../../../utils/helpers";
import { StarRating } from "../../../../components/StarRating/StarRating";

const BlockLibrary = () => {
  savePathToLocalStorage();
  const [currentBlock, setCurrentBlock] = useState<any>([]);
  const route: any = useRouteMatch();
  const { blockLibraries } = useBlockLibraries();
  const search = (e) => {
    console.log(e.target.value);
  };

  const filterCurrentBlockLibrary = (blockLibraryId: any) => {
    debugger;
    setCurrentBlock(
      blockLibraries?.filter(
        (blockLibrary) => blockLibrary.id == blockLibraryId
      )
    );
  };

  useEffect(() => {
    filterCurrentBlockLibrary(route?.params?.id);
  }, [blockLibraries, route]);

  console.log("Current block", currentBlock);

  return (
    <Fragment>
      <div>
        <Header title="Block Library" goBackTo="/marketplace/block-libraries" />
      </div>
      <div>
        <div className="main-content-flex">
          {currentBlock?.length > 0 && (
            <div className="block-library-container">
              <div className="block-library-header">
                <img
                  src={currentBlock[0].thumbnailUrl}
                  alt={currentBlock[0].name}
                />
              </div>
              <div className="block-library-body">
                <div className="body-title">{currentBlock[0].name}</div>
                <div className="body-ratings">
                  <StarRating />
                  <div className="body-ratings-count">
                    0 ratings
                    {/* {currentBlock[0].rating} */}
                  </div>
                </div>
                <div className="body-details">
                  <div className="body-details-price">
                    <div className="body-details-price-title">Price:</div>
                    <div className="body-details-price-content">Free</div>
                    {/* <div>{currentBlock[0].price}</div> */}
                  </div>
                  <div className="body-details-description">
                    <div className="body-details-description-title">
                      Description:
                    </div>
                    <div className="body-details-description-content">
                      {currentBlock[0].description}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default BlockLibrary;
